import { isNumber, isString, isStringNumber } from '@/components/base-components/utils/types';

export function addUnit(value, defaultUnit = 'px') {
    if (!value) return '';
    if (isNumber(value) || isStringNumber(value)) return `${value}${defaultUnit}`;
    if (isString(value)) return value;
}
